import { React } from "react";

const ViewAccessedCarsHistory = () => {
	return <div></div>;
};

export default ViewAccessedCarsHistory;
